import axios from '../axios'
import { convertParams } from 'src/utils/utils'
import { BANNERROUTES } from 'src/router/Api'

export const getListBanner = async (params: any) =>
	await axios.get(BANNERROUTES.name, { params: convertParams(params) })

export const createBanner = async (body: any) =>
	await axios.post(BANNERROUTES.name, body)

export const updateBanner = async (id: string, body: any) =>
	await axios.put(`${BANNERROUTES.name}/${id}`, body)

export const deleteBanner = async (id: string) =>
	await axios.delete(`${BANNERROUTES.name}/${id}`)
